import React from 'react';
import { useIntl } from 'gatsby-plugin-intl';
import { useChartTooltipContext } from '../../../../store/ChartTooltipContext';
import { useGatsbyContext } from '../../../../store/GatsbyContext';
import { findPiLabel } from '../../../../utils/findPiLabel';
import { TooltipElementTable, TooltipTableDataCell } from '../../../tooltipElementTable/tooltipElementTable.styles';

const TooltipElement = ({ name, score, piLabel, color }) => {
  const { formatMessage } = useIntl();

  return (
    <TooltipElementTable>
      <thead>
        <tr>
          <th>{formatMessage({ id: 'Indicator' })}</th>
          <th>{formatMessage({ id: 'Score' })}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <TooltipTableDataCell>
            {piLabel}: {formatMessage({ id: name })}
          </TooltipTableDataCell>
          <TooltipTableDataCell color={color}>
            <span>{formatMessage({ id: score })}</span>
          </TooltipTableDataCell>
        </tr>
      </tbody>
    </TooltipElementTable>
  );
};

export const RadialChartHomepageTooltip = () => {
  const tooltip = useChartTooltipContext();
  const { piLabels } = useGatsbyContext();

  if (!tooltip.data) return null;

  const currentPiLabelValue = findPiLabel(piLabels, tooltip.data.indicator);

  return (
    <TooltipElement
      name={currentPiLabelValue}
      score={tooltip.data.score}
      piLabel={tooltip.data.indicator}
      color={tooltip.data.data.color}
    />
  );
};
